module.exports = __webpack_public_path__ + "c5ca9b0dba8bf93951eb10836bf13489.svg";